export const tr = {
    cancel: 'İptal',
    close: 'Kapat',
    'feedback-icon-hint': 'Yeni arayüzle ilgili yorum yaz',
    later: 'Daha sonra',
    'promo-content': 'Artık yeni Direct arayüzünün beta sürümüyle ilgili geri bildirim bırakabilirsiniz.',
    'result-title': 'Teşekkürler! Yorumunuz Direct geliştiricilerine gönderildi',
    send: 'Gönder',
    'switch-to-old-interface-link': 'Eski arayüze dönmek istiyorum',
    'thanks-text':
        "Beta sürümümüzü aktif olarak geliştiriyoruz; her hafta yeni özellikler ekliyor ve kullanıcılarımızın bildirdikleri  sıkıntıları ortadan kaldırıyoruz. Teste katıldığınız için teşekkür ederiz! Geri bildiriminiz, Direct'in daha iyi ve daha kullanılabilir olmasında büyük rol oynayacak.",
    title: 'Bize ulaşın',
    'we-will-connect-to-you-for-questions':
        'Çalışmalarımız devam ederken ek bilgilere ihtiyacımız olabilir; böyle bir durumda sizinle ayrıca irtibata geçeceğiz.',
    'write-any-feedback': 'Lütfen, yeni arayüzle ilgili düşüncelerinizi paylaşın.',
    'write-feedback': 'Yorum yaz'
};
